import { AppError } from '@/core/errors/AppError';
import { mensajeParaCodigo } from '@/core/errors/errorMessages';
export function setupErrorInterceptor(client) {
    client.interceptors.response.use((r) => r, (error) => {
        if (!error.response) {
            return Promise.reject(new AppError('NETWORK', mensajeParaCodigo('NETWORK'), undefined));
        }
        const data = error.response.data ?? {};
        const codigo = data.codigo ?? data.title ?? 'INTERNO_DESCONOCIDO';
        const mensaje = data.detail ?? mensajeParaCodigo(codigo);
        const errores = data.errores?.map((e) => ({ campo: e.campo, mensaje: e.mensaje }));
        return Promise.reject(new AppError(codigo, mensaje, error.response.status, data.requestId, errores));
    });
}
